import script from "./ProjectSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectSummary.vue?vue&type=script&setup=true&lang=js"

import "./ProjectSummary.vue?vue&type=style&index=0&id=45b15324&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45b15324"]])

export default __exports__